<app-header></app-header>
<app-set-meta title="ログイン｜Forbes CAREER"></app-set-meta>
<div class="wrapper">
  <div class="pc_contents_wrapper">
    <ng-container *ngIf="false; else maintenance">
      <h1>ログイン</h1>

      <p>
        登録がお済みでない方は
        <a [routerLink]="['/signup', backUrl]">こちら</a>
      </p>

      <div *ngIf="errorMessage" class="alert alert-warning">{{ errorMessage }}</div>
      <div class="form_wrapper">
        <button class="btn btn-facebook btn-block" (click)="signinWithFacebook()">Facebookでログイン</button>
        <button class="btn btn-google btn-block" (click)="signinWithGoogle()">Googleでログイン</button>

        <div class="or"><span>または</span></div>

        <form [formGroup]="signinForm">
          <div class="form-group">
            <input placeholder="メールアドレス" formControlName="email" class="form-control" />
          </div>
          <div class="form-group">
            <input type="password" placeholder="パスワード" formControlName="password" class="form-control" />
          </div>
          <button type="button" (click)="doSignin()" class="btn btn-primary btn-block">ログイン</button>
          <a routerLink="/passwd">パスワードを忘れた場合</a>
        </form>
      </div>
    </ng-container>

    <ng-template #maintenance>
      <div class="maintenance">
        <p class="maintenance__text">
          サイトの移行作業に伴い、以下の期間中はログインいただけません。
          <br />
          <br />
          <span class="maintenance__text__date">12/5（月）10:00 - 12/9（金）終日</span>
          <br />
          <br />
          ご不便をおかけしますが、ご理解のほど宜しくお願い申し上げます。
          <br />
          <br />
          お問合せ：career_cs@linkties.com
        </p>
      </div>
    </ng-template>
  </div>
  <app-footer></app-footer>
</div>
<!-- /.wrapper -->
